import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, palette } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamily, weight } from "@clockwise/web-commons/src/styles/type.styles";

const dayPickerContainer: CSSProperties = {
  width: "100%",
  height: 100,
  borderBottom: `1px solid ${greys.cloudyBlue}`,
};

const dayPickerTop: CSSProperties = {
  height: 54,
  display: "flex",
  flexDirection: "row",
};

const dayPickerBottom: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  paddingLeft: 8,
  paddingRight: 8,
};

const dayPicker: CSSProperties = {
  padding: "15px 0 15px 8px",
  lineHeight: "26px",
  width: 135,
};

const dayPickerTextField: CSSProperties = {
  fontFamily,
  fontSize: 16,
  fontWeight: weight.bold,
  color: palette.blueDusk,
  height: 26,
  cursor: "pointer",
  width: "unset",
};

const dayPickerTextFieldInput: CSSProperties = {
  cursor: "pointer",
};

const dayPickerDropDownContainer: CSSProperties = {
  fontFamily,
  color: palette.blueDusk,
  fontWeight: "bold",
};

const dayPickerChevronContainer: CSSProperties = {
  flex: "1",
  paddingTop: 5,
  textAlign: "right",
};

const dayPickerTodayButtonContainer: CSSProperties = {
  padding: "12px 8px 12px 0",
};

const dayPickerTodayButton: CSSProperties = {
  fontSize: 12,
  fontWeight: "bold",
  color: greys.slate,
  padding: 0,
  height: 33,
  minHeight: "unset",
};

const dayPickerAvatar: CSSProperties = {
  paddingRight: 8,
};

export const styles = {
  dayPickerContainer,
  dayPickerTop,
  dayPickerBottom,
  dayPicker,
  dayPickerTextField,
  dayPickerTextFieldInput,
  dayPickerDropDownContainer,
  dayPickerChevronContainer,
  dayPickerTodayButtonContainer,
  dayPickerTodayButton,
  dayPickerAvatar,
};
